// extracted by mini-css-extract-plugin
var _1 = "FoldedComments-module__animateUploadProgressBarWidth--Rn53X";
var _2 = "FoldedComments-module__animatedBackground--DQfxH";
var _3 = "FoldedComments-module__container--bGAZA";
var _4 = "FoldedComments-module__isExpanded--zqLZk";
var _5 = "FoldedComments-module__lineBottom--cZ1Ra";
var _6 = "FoldedComments-module__lineContainer--j8kDc";
var _7 = "FoldedComments-module__lineTop--kLgxK";
var _8 = "FoldedComments-module__link--xAIuS";
var _9 = "FoldedComments-module__moreCountContainer--Y1juL";
var _a = "FoldedComments-module__showLineWhenFolded--mdl2Y";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "isExpanded", _5 as "lineBottom", _6 as "lineContainer", _7 as "lineTop", _8 as "link", _9 as "moreCountContainer", _a as "showLineWhenFolded" }
